/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Card_Closedtitle3Inputs */

const en_coinvestments_closedeal_card_closedtitle3 = /** @type {(inputs: Coinvestments_Closedeal_Card_Closedtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal closed`)
};

/**
* | output |
* | --- |
* | "Deal closed" |
*
* @param {Coinvestments_Closedeal_Card_Closedtitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_card_closedtitle3 = /** @type {((inputs?: Coinvestments_Closedeal_Card_Closedtitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Card_Closedtitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_card_closedtitle3(inputs)
});
export { coinvestments_closedeal_card_closedtitle3 as "coInvestments_closeDeal_card_closedTitle" }